module.exports = __webpack_public_path__ + "static/media/osm.7efceb91.png";